import { Component, Input, OnInit } from '@angular/core';
import { LevelOfServiceService } from 'src/app/service/level-of-service/level-of-service.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css']
})
export class TooltipComponent implements OnInit {
  @Input() trip;
  @Input() spaceType;
  @Input() los;
  @Input() fundingSource;
  @Input() assist;
  constructor(
    private levelOfServiceService : LevelOfServiceService
  ) { }

  ngOnInit() {
    
  }
}
